module.exports = __webpack_public_path__ + "img/dsci0046.ce16b295.jpg";